import React from "react";
import { Text, View } from "react-native";

import { useGameplayStore } from "../../game/stores/useGameplayStore";
import { getLoadedGraphVersion } from "../../services/dataLoader";
import { useAssetStore } from "../../stores/useAssetStore";
import { APP_VERSION } from "../../utils/appVersion";
import { BUILD_COMMIT } from "../../dev/buildInfo";
import { longestStreak } from "../../dev/sessionLog";
import { devStyles as s } from "./devStyles";

const Line: React.FC<{ k: string; v: string | number }> = ({ k, v }) => (
  <Text selectable style={s.text}>
    <Text style={s.dim}>{k} </Text>
    {String(v)}
  </Text>
);

/** Graph identity, build, and the current game's numbers. */
const InfoSection: React.FC = () => {
  const graphHash = useAssetStore((st) => st.graphHash);
  const graphVersion = useAssetStore((st) => st.graphVersion);
  const g = useGameplayStore();
  const par = Math.max(0, g.optimalPath.length - 1);
  const distance = Math.max(0, g.suggestedPathFromCurrent.length - 1);
  return (
    <View testID="dev-info">
      <Line k="graph" v={graphVersion ?? getLoadedGraphVersion() ?? "?"} />
      <Line k="graph_hash" v={graphHash ?? "?"} />
      <Line k="build" v={`v${APP_VERSION} · ${BUILD_COMMIT}`} />
      <Line
        k="pair"
        v={
          g.startWord
            ? `${g.startWord} → ${g.targetWord} (${g.gameStatus})`
            : "—"
        }
      />
      <Line
        k="par / to go"
        v={`${par} / ${distance} · moves ${g.playerPath.length - 1}`}
      />
      <Line
        k="streak / longest"
        v={`${g.streak} / ${longestStreak(g.optimalChoices)}`}
      />
    </View>
  );
};

export default InfoSection;
